import { jobDatabaseMetaType } from "../../../Types/jobDatabaseTypes";

export const getSummaryItems = (meta: jobDatabaseMetaType) => {
  return [
    {
      value: meta?.customers ?? 0,
      label: "Customers",
      flag: -1,
    },
    {
      value: meta?.jobs ?? 0,
      label: "Jobs",
      flag: -1,
    },
    {
      value: meta?.truckingJobs ?? 0,
      label: "Trucking Jobs",
      flag: -1,
    },
    {
      value: meta?.truckingAndMaterialJobs ?? 0,
      label: "Trucking & Material Jobs",
      flag: -1,
    },
    {
      value: meta?.bothJobs ?? 0,
      label: "Both Jobs",
      flag: 4,
    },
  ];
};
